import List from './AnalyzeCollusion';

export default List;
